exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/jenkins-agent/workspace/ng-labportal-prod-build/src/app/modify-order/special-instructions/special-instructions.component.css
// module id = ../../../../../src/app/modify-order/special-instructions/special-instructions.component.css
// module chunks = main